<div
  [attr.data-at-installation-id]="subscription.installationId"
  class="subscription-container flex flex-col justify-between items-center"
>
  <div class="full-width flex flex-row gap-[8px]">
    <div class="device-img">
      <ng-container *ngIf="subscription?.deviceImageUrl; else hideImage">
        <img src="{{ subscription.deviceImageUrl }}" />
      </ng-container>
      <ng-template #hideImage>
        <mat-icon class="hide-image">hide_image</mat-icon>
      </ng-template>
    </div>
    <div class="details-container flex flex-col gap-[8px]">
      <div class="title flex flex-row justify-between items-stretch">
        <div class="flex flex-col">
          <ng-container *ngIf="subscription?.registeredInstallation; else unregisteredDevice">
            <a
              data-at-installation-name
              [routerLink]="['/installations/', subscription.installationId]"
              [queryParams]="{ gatewaySerial: subscription?.gatewaySerial }"
              gtm="onGoToPage"
              gtmAction="Installation details"
              gtmCategory="bookingOverview"
            >
              <h1 class="installation-link">
                <ng-container *ngIf="subscription.marketingName; else defaultMarketingName">
                  {{ subscription.marketingName }}
                </ng-container>
                <ng-template #defaultMarketingName>
                  {{ '+INSTALLATIONS.INSTALLATIONS.INSTALLATION_OF' | translate }}
                  {{ subscription.ownerName }}
                </ng-template>
              </h1>
            </a>
          </ng-container>
          <ng-template #unregisteredDevice>
            <h4>{{ '+BOOKING.OVERVIEW.SUBSCRIPTION.UNREGISTERED_DEVICE.TITLE' | translate }}</h4>
          </ng-template>
          <p data-at-boiler-id>{{ subscription.boilerId }}</p>
        </div>
        <app-booking-package-badge
          [attr.data-at-subscription-type]="
            subscription?.trial ? subscriptionsPlanType.Trial : subscription?.plan
          "
          *ngIf="!isExpired"
          [packageType]="subscription?.plan"
          [isTrial]="subscription?.trial"
          size="small"
        ></app-booking-package-badge>
      </div>
      <p data-at-owner-name>{{ subscription.ownerName }}</p>
      <p data-at-location>
        {{ subscription.installationLocation }}
      </p>
      <p>
        <span
          data-at-automatic-extension
          *ngIf="
            subscription.plan === subscriptionsPlanType.Pro &&
              subscription.trial === false &&
              subscription.status?.toLowerCase() === subscriptionsStatusType.active;
            else expirationDate
          "
        >
          {{ '+BOOKING.OVERVIEW.SUBSCRIPTION.AUTOMATIC_EXTENSION' | translate }}:
        </span>
        <ng-template #expirationDate>
          <span data-at-expiration-date>
            {{ '+BOOKING.OVERVIEW.SUBSCRIPTION.EXPIRATION_DATE' | translate }}:
          </span>
        </ng-template>
        <span [attr.data-at-end-date]="subscription.expirationDate | date">{{
          subscription.expirationDate | date
        }}</span>
      </p>
      <p
        data-at-subscription-duration
        *ngIf="subscription.status?.toLowerCase() === subscriptionsStatusType.canceled"
      >
        {{ '+BOOKING.OVERVIEW.SUBSCRIPTION.DURATION' | translate }}:
        {{ getLeftDays(subscription.expirationDate) }}
      </p>
      <p data-at-booked-by>
        {{ '+BOOKING.OVERVIEW.SUBSCRIPTION.BOOKING_FROM' | translate }}:
        <ng-container *ngIf="subscription.subscribedByName; else noSubscriberName">
          {{ subscription.subscribedByName }}
        </ng-container>
        <ng-template #noSubscriberName>
          {{ subscription.subscribedBy }}
        </ng-template>
      </p>
    </div>
  </div>
  <!-- uncomment after VIG-5482 -->
  <!-- <div class="btn-container full-width flex flex-row justify-center items-center">
    <ng-container *ngIf="authStore.canManageSubscriptions$ | async">
      <button
        *ngIf="bookingService.isBoilerSerialOnBookingWhiteList(subscription?.boilerId)"
        data-at-upgrade-to-pro-button
        mat-raised-button
        color="primary"
        gtm="onSet"
        gtmAction="Pro plan"
        gtmCategory="bookingOverview"
        (click)="onProceedSubscription(subscription?.boilerId)"
      >
        {{ '+BOOKING.OVERVIEW.BUTTON.BUY_PRO' | translate }}
      </button>
    </ng-container>
  </div> -->
</div>
